import styled from 'styled-components';

import { sizeDown, sizeUp } from '~/theme';
import ShapeItemMolecule from '~molecules/ShapeItem';

const columnGap = '35rem';

export const Container = styled.div({
  display: 'flex',
  flexWrap: 'wrap',
  rowGap: '15rem',
  columnGap,

  paddingInline: sizeUp('10rem', ['md', '30rem']),
});

export const ShapeItem = styled(ShapeItemMolecule)({
  width: `calc(${sizeDown(
    '50%',
    ['md', '33.33%'],
    ['lg', '25%']
  )} - ${columnGap})`,
});
